/**
 * Get page limit from user context for batch billing
 * @param {Object} userContext - User context object
 * @returns {number|undefined} - Page limit or undefined
 */
export const getPageLimit = (userContext) => {
  if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.batch_billing;
  }
};

/**
 * Get saved page number from user context for batch billing
 * @param {Object} userContext - User context object
 * @returns {number|undefined} - Saved page number or undefined
 */
export const getSavedPageNumber = (userContext) => {
  if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.batch_billing_page;
  }
};

/**
 * Get file path for pagination preferences
 * @returns {Object} - Path object with module, subModule, and listName
 */
export const getFilePathForPagination = () => {
  return { module: 'billings', subModule: '', listName: 'batch_billing' };
};
